"use client";

import React from "react";
import RouteError from "@/app/components/RouteError";

export default function AppointmentLocationError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <RouteError
      {...props}
      title="We couldn't load this location"
      description="There was a problem loading this location. Please try again, or browse all of our locations."
    />
  );
}
